import React from 'react';
import { ReactComponent as IconImpacts } from '../../../../svg/icon_Impacts.svg';
import { disabledStyle } from '../AirtimePlanningStyles';
import { RadioButton } from '@adserve/adserve-react-components';

const labelStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    height: '20px',
    marginRight: '12px'
};

const flexSpaceBetween = {
    display: 'flex',
    justifyContent: 'space-between'
};

const flexRow = {
    display: 'flex',
    flexDirection: 'row'
};

const radioLableStyle = {
    ...labelStyle,
    fontWeight: 'Bold',
    marginLeft: 8,
    display: 'flex'
};

const radioButton = {
    display: 'flex',
    cursor: 'pointer'
};

const Legend = ({
    hasPlan,
    quoteExpired,
    isPlanning,
    showImpacts,
    setShowImpacts,
    showBaseImpacts,
    setShowBaseImpacts
}) => {
    const barIcon = {
        boxSizing: 'border-box',
        border: quoteExpired ? '1px solid #A6A6A6' : '1px solid #FFB50C',
        backgroundColor: quoteExpired ? '#CCCCCC' : '#FDF1D6',
        width: 17
    };

    const handleRadioChange = () => {
        setShowImpacts(false);
        setShowBaseImpacts(false);
    };
    const handleBaseRadioChange = (isBase) => {
        setShowBaseImpacts(isBase);
        setShowImpacts(!isBase);
    };
    const handleTargetRadioChange = (value) => {
        setShowImpacts(value);
        setShowBaseImpacts(!value);
    };
    return (
        <div style={flexSpaceBetween}>
            <div
                style={{
                    ...flexRow,
                    marginLeft: 24.5,
                    alignItems: 'baseline',
                    ...(!hasPlan || isPlanning
                        ? { ...disabledStyle, width: 88, height: 33 }
                        : { marginTop: 15 })
                }}
            >
                {hasPlan && !isPlanning && (
                    <>
                        <span style={{ ...labelStyle, fontWeight: 'Bold' }}>
                            {window.translate('Spots')}
                        </span>
                        <div
                            style={{ ...barIcon, height: 18, marginLeft: 10 }}
                        />
                        <div style={{ ...barIcon, height: 9, marginLeft: 3 }} />
                    </>
                )}
            </div>
            <div
                style={{
                    ...flexRow,
                    ...(!hasPlan || isPlanning
                        ? {
                              ...disabledStyle,
                              width: 110,
                              height: 33,
                              marginRight: 25.5,
                              alignItems: 'baseline'
                          }
                        : {
                              marginTop: 15,
                              alignItems: 'center',
                              justifyContent: 'end',
                              width: 140
                          })
                }}
            >
                {hasPlan && !isPlanning && (
                    <>
                        <div
                            style={{
                                marginTop: 4,
                                display: 'flex',
                                marginRight: 10
                            }}
                        >
                            <IconImpacts
                                style={{
                                    fill: quoteExpired ? '#CCCCCC' : '#FD9A00'
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 4, display: 'flex' }}>
                            <div
                                onClick={() => handleBaseRadioChange(true)}
                                style={{
                                    ...radioButton,
                                    marginTop: 4,
                                    paddingTop: 5,
                                    paddingLeft: 6,
                                    backgroundColor: showBaseImpacts
                                        ? '#FFD287'
                                        : '#F0F0F0',
                                    marginRight: 20
                                }}
                            >
                                <RadioButton
                                    checkStyle={
                                        quoteExpired
                                            ? {
                                                border: '2px solid #CCCCCC',
                                                backgroundColor: '#CCCCCC'
                                            }
                                            : {}
                                    }
                                    value={showBaseImpacts}
                                />
                                <span
                                    style={{
                                        ...radioLableStyle,
                                        width: 100,
                                        backgroundColor: showBaseImpacts
                                            ? '#FFD287'
                                            : '#F0F0F0'
                                    }}
                                >
                                    {window.translate('Base Impacts')}
                                </span>
                            </div>
                            <div
                                onClick={() => handleTargetRadioChange(true)}
                                style={{
                                    ...radioButton,
                                    marginTop: 4,
                                    marginRight: 20,
                                    paddingTop: 5,
                                    paddingLeft: 6,
                                    backgroundColor: showImpacts
                                        ? '#FFD287'
                                        : '#F0F0F0'
                                }}
                            >
                                <RadioButton
                                    checkStyle={
                                        quoteExpired
                                            ? {
                                                border: '2px solid #CCCCCC',
                                                backgroundColor: '#CCCCCC'
                                            }
                                            : {}
                                    }
                                    value={showImpacts}
                                />
                                <span
                                    style={{
                                        ...radioLableStyle,
                                        width: 100,
                                        backgroundColor: showImpacts
                                            ? '#FFD287'
                                            : '#F0F0F0'
                                    }}
                                >
                                    {window.translate('Target Impacts')}
                                </span>
                            </div>
                            
                            <div
                                onClick={() => handleRadioChange()}
                                style={{
                                    ...radioButton,
                                    marginTop: 4,
                                    paddingTop: 5,
                                    paddingLeft: 6,
                                    backgroundColor:
                                        !showImpacts && !showBaseImpacts
                                            ? '#FFD287'
                                            : '#F0F0F0',
                                    marginRight: 20
                                }}
                            >
                                <RadioButton
                                    checkStyle={
                                        quoteExpired
                                            ? {
                                                  border: '2px solid #CCCCCC',
                                                  backgroundColor: '#CCCCCC'
                                              }
                                            : {}
                                    }
                                    value={!showImpacts && !showBaseImpacts}
                                />
                                <span
                                    style={{
                                        ...radioLableStyle,
                                        width: 42,
                                        backgroundColor:
                                            !showImpacts && !showBaseImpacts
                                                ? '#FFD287'
                                                : '#F0F0F0'
                                    }}
                                >
                                    {window.translate('Costs')}
                                </span>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Legend;
